import React, { useEffect } from 'react'
import { Avatar, FormInstance, Select } from 'antd'
import Spinner from 'components/Spinner'
import { getNameSignature } from 'helper/utility'
import { useGetTeamOfLeagueAndOrganization } from 'api/Team/LeagueTeam'
import { LeagueTeamResp } from 'types/team/leagueTeam'

interface LeagueTeamSelectProps {
  form: FormInstance
  data: string[] | undefined
  organizationId: string
  leagueId: string
}

const LeagueTeamSelect: React.FC<LeagueTeamSelectProps> = ({
  form,
  data,
  organizationId,
  leagueId,
}) => {
  const {
    isLoading,
    isFetching,
    refetch,
    isError,
    data: teams,
  } = useGetTeamOfLeagueAndOrganization(leagueId, organizationId)

  useEffect(() => {
    refetch()
  }, [organizationId])

  return (
    <div>
      <Select
        className="h-50px select-field"
        placeholder={'Select Team'}
        defaultValue={data}
        mode={'multiple'}
        onChange={(v, item: { value: string; key: string }) => {
          form.setFieldsValue({
            teamIds: v,
          })
        }}
      >
        {isLoading || isFetching ? (
          <div className="py-40px">
            <Spinner />
          </div>
        ) : isError ? (
          <div className="py-40px flex justify-center align-center">
            <p>Something went wrong while loading teams</p>
          </div>
        ) : (
          teams.map((team: LeagueTeamResp) => (
            <Select.Option key={team._id} value={team._id}>
              <div className="flex align-center gap-10px">
                <Avatar size={20} src={team.team.profilePhoto?.thumb}>
                  {getNameSignature(team.team.name)}
                </Avatar>
                <p className="text-14 w-600">{team.team.name}</p>
              </div>
            </Select.Option>
          ))
        )}
      </Select>
    </div>
  )
}

export default LeagueTeamSelect
